import React from 'react';
import { motion } from 'framer-motion';
export function ForAgencies() {
  return <section className="py-24 border-b border-stone-300" data-id="element-1014">
      <div className="max-w-6xl mx-auto px-6" data-id="element-1015">
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-1016">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-1017">
            {/* Left: Benefits grid */}
            <div className="order-2 lg:order-1" data-id="element-1018">
              <div className="grid grid-cols-2 border border-stone-300" data-id="element-1019">
                <div className="p-6 border-r border-b border-stone-300" data-id="element-1020">
                  <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-4" data-id="element-1021">
                    01
                  </p>
                  <p className="font-medium text-stone-900 mb-2" data-id="element-1022">
                    Instant Options
                  </p>
                  <p className="text-sm text-stone-600" data-id="element-1023">
                    Good/Better/Best packages in seconds
                  </p>
                </div>

                <div className="p-6 border-b border-stone-300" data-id="element-1024">
                  <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-4" data-id="element-1025">
                    02
                  </p>
                  <p className="font-medium text-stone-900 mb-2" data-id="element-1026">
                    Faster Approvals
                  </p>
                  <p className="text-sm text-stone-600" data-id="element-1027">
                    Real-time availability, no waiting
                  </p>
                </div>

                <div className="p-6 border-r border-stone-300" data-id="element-1028">
                  <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-4" data-id="element-1029">
                    03
                  </p>
                  <p className="font-medium text-stone-900 mb-2" data-id="element-1030">
                    Track Everything
                  </p>
                  <p className="text-sm text-stone-600" data-id="element-1031">
                    Holds, deadlines, deposits in one place
                  </p>
                </div>

                <div className="p-6" data-id="element-1032">
                  <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-4" data-id="element-1033">
                    04
                  </p>
                  <p className="font-medium text-stone-900 mb-2" data-id="element-1034">Win More</p>
                  <p className="text-sm text-stone-600" data-id="element-1035">
                    Less back-and-forth, higher win rate
                  </p>
                </div>
              </div>
            </div>

            {/* Right: Content */}
            <div className="order-1 lg:order-2" data-id="element-1036">
              <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-6" data-id="element-1037">
                For Agencies
              </p>

              <h2 className="font-serif text-4xl md:text-5xl tracking-tight leading-[1.1] text-stone-900 mb-8" data-id="element-1038">
                Close groups faster
              </h2>

              <p className="text-lg text-stone-600 leading-relaxed mb-8" data-id="element-1039">
                Agencies are the lifeblood of group travel. BlockQuote gives
                them the tools to present options instantly, secure inventory,
                and win more business for their clients.
              </p>

              <ul className="space-y-4 text-stone-600" data-id="element-1040">
                <li className="flex items-start gap-3" data-id="element-1041">
                  <span className="w-1 h-1 bg-red-600 mt-2.5 flex-shrink-0" data-id="element-1042"></span>
                  <span data-id="element-1043">No more waiting days for an email reply</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-1044">
                  <span className="w-1 h-1 bg-stone-400 mt-2.5 flex-shrink-0" data-id="element-1045"></span>
                  <span data-id="element-1046">Professional, branded proposals ready to forward</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-1047">
                  <span className="w-1 h-1 bg-stone-400 mt-2.5 flex-shrink-0" data-id="element-1048"></span>
                  <span data-id="element-1049">
                    Clear visibility into hold expiries and deposit dates
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}